import { style, animate, trigger, transition, state } from '@angular/animations';

export const triggerAnimationShowHide = trigger('animationShowHide', [
  state('false', style({ height: '0px', overflow: 'hidden' })),
  state('true', style({ height: '*', overflow: 'hidden' })),
  transition('true <=> false', animate('900ms ease-in-out')),
]);